const MOUSE_LEFT = 0;
//const MOUSE_RIGHT = 2;

export default class ImageViertController {


    constructor(ctx) {
        this.ctx = ctx;
        this.width = 0;
        this.centerX = 0;
        this.height = 0;
        this.centerY = 0;
        this.zoom = 1;
        this.lookAt = [0,0]
        this.data = null;

        this.mouseMoving = false;
        this.mouseStart = [0,0];
        this.availableWidth = 0;
        this.availableHeight = 0;
    }

    setWidth(w) {
        this.width = w;
        this.centerX = w/2;
        this.ctx.canvas.width = w;
    }

    setHeight(h) {
        this.height = h;
        this.centerY = h/2;
        this.ctx.canvas.height = h;
    }

    setData(d) {
        this.data = d;
        this.calculateAvailableMove();
    }

    reset() {
        this.zoom = 1;
        this.lookAt = [0,0];
        this.calculateAvailableMove();
    }

    calculateAvailableMove() {
        this.availableWidth = (this.data ? (this.data.width * this.zoom - this.width) : 0);
        this.availableHeight = (this.data ? (this.data.height * this.zoom - this.height) : 0);
    }


    manageScroll(e) {
        e.preventDefault();
        /*const senseY = e.deltaY / Math.abs(e.deltaY || 1);
        const senseX = e.deltaX / Math.abs(e.deltaX || 1);
        const isHorizontal = e.shiftKey || false;
        const isZoom = e.ctrlKey || false;

        if (isZoom) {
            if (senseY > 0) {
                this.zoomOut();
            } else if (senseY < 0) {
                this.zoomIn();
            }
        }/* else {
            if (senseX !== 0) {
                this.incrementLookingAt(0.5 * senseX, 0);
            }

            if (senseY !== 0) {
                if (isHorizontal) {
                    this.incrementLookingAt(0.5 * senseY, 0);
                } else {
                    this.incrementLookingAt(0, 0.5 * senseY, true);
                }
            }
        }*/
    }

    zoomOut() {
        if (this.zoom < 16) {
            this.zoom *= 2;
            this.calculateAvailableMove();
            this.lookAt = [this.lookAt[0]*2, this.lookAt[1]*2];
            this.normalizeLookAt([0,0]);
        }
    }

    zoomIn() {
        if (this.zoom > 0.25) {
            this.zoom /= 2;
            this.calculateAvailableMove();
            this.lookAt = [this.lookAt[0]/2, this.lookAt[1]/2];
            this.normalizeLookAt([0,0]);
        }
    }

    getCurrentZoom() {
        return this.zoom * 100;
    }

    normalizeLookAt(delta) {
        this.lookAt = [
            Math.min(Math.max(delta[0] + this.lookAt[0],-this.availableWidth), 0),
            Math.min(Math.max(delta[1] + this.lookAt[1],-this.availableHeight), 0),
        ];
    }

    
    resize() {
        const size = this.ctx.canvas.getBoundingClientRect();
        this.setWidth(size.width);
        this.setHeight(size.height);

        let ratio = window.devicePixelRatio;
        this.ctx.canvas.width = size.width * ratio;
        this.ctx.canvas.height = size.height * ratio;
        this.ctx.scale(ratio, ratio);
    }

    init() {
        
    }

    clear() {

    }

    mouseDown(e) {
        if (e.button === MOUSE_LEFT) {
            this.mouseMoving = true;
            this.mouseStart = [e.clientX, e.clientY];
        }
    }

    mouseUp(e) {
        if (e.button === MOUSE_LEFT) {
            this.mouseMoving = false;
        }
    }

    mouseMove(e) {
        if (this.mouseMoving) {
            const delta = [e.clientX - this.mouseStart[0], e.clientY - this.mouseStart[1]];
            this.mouseStart = [e.clientX, e.clientY];

            this.normalizeLookAt(delta);
        }

    }

    draw() {
        this.ctx.clearRect(0, 0, this.width, this.height);

        if (this.data) {
            this.ctx.drawImage(this.data, 
                0, 0, this.data.width, this.data.height,
                0 + this.lookAt[0], 0 + this.lookAt[1], this.data.width*this.zoom, this.data.height*this.zoom
            );
        }
    }


}